import { BorderBoxPayload } from 'types/assessment-payload';

export const DOUBLE_BORDER_SIZE = 3;

export const CHECK_DOT_SIZE = 15;

export const UI_POSITION_ADJUSTMENT = 3;

export function getWidth(borderBox: BorderBoxPayload) {
  return borderBox.bottomRightX - borderBox.topLeftX;
}

export function getHeight(borderBox: BorderBoxPayload) {
  return borderBox.bottomRightY - borderBox.topLeftY;
}

export function getTop(borderBox: BorderBoxPayload) {
  return borderBox.topLeftY;
}

export function getLeft(borderBox: BorderBoxPayload) {
  return borderBox.topLeftX;
}
